const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLightning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8676 6.03352L7.13156 13.8332L11.7343 13.8332L11.7343 20.5661L18.4703 12.7665L13.8676 12.7665L13.8676 6.03352ZM14.0333 2.57779C14.7116 1.79238 16.0009 2.27211 16.0009 3.30984L16.001 10.6332L20.6844 10.6332C21.6433 10.6332 22.1588 11.7595 21.5321 12.4852L11.5686 24.0219C10.8903 24.8073 9.60095 24.3275 9.60095 23.2898L9.60095 15.9665L4.91748 15.9665C3.95863 15.9665 3.44313 14.8401 4.06984 14.1144L14.0333 2.57779Z",
    fill: "#1D313D",
    style: {
      fill: "#1D313D",
      fill: "color(display-p3 0.1137 0.1922 0.2392)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLightning);
export default __webpack_public_path__ + "static/media/icon-lightning.af4efb24bf7c30a00f487ab23504bc95.svg";
export { ForwardRef as ReactComponent };